import { sendRequest } from "../axios";
export default {
  state: {
    orgTabs: [],
    OrganisationUM: null
  },
  mutations: {
    SET_ORG_TABS(state, commit) {
      state.orgTabs = commit;
    },
    setOrganisationUM(state, payload) {
      state.OrganisationUM = payload;
    }
  },
  actions: {
    getOrgSettings({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getOrgSettings", "get", data).then(response => {
          commit("SET_ORG_TABS", response.data.orgTabs);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    removeOrganization({ commit }, payload) {
      return new Promise((resolve, reject) => {
        sendRequest("api/removeOrganization", "post", { id: payload.id }).then(
          res => {
            resolve(res.data);
          }
        );
      });
    }
  },
  getters: {
    getOrgTabs: state => state.orgTabs,
    getOrganisationUM: state => state.OrganisationUM
  }
};
